import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import Dialog, { CloseDialog } from "components/Dialog";
import Button from "components/Button";
import { resolveObj, useStateSelector } from "utils/field";
import { actions } from "../_ducks";
import { actions as commUpgradeActions } from "features/Community/Upgrades/_ducks";
import { selectUpgradePackages } from "../_ducks/selectors";
import { selectCommUpgradePackages } from "features/Community/Upgrades/_ducks/selectors";
import { removeUpgradeFromCommunity } from "store/community/actions";
import classes from "./PackageDeleteDialog.module.scss";

const { deleteUpgradePackage } = actions;
const { deleteCommUpgradePackage } = commUpgradeActions;

const PackageDeleteDialog = ({ toDelete, toggleToDelete, isCommunity = false, modelChange = () => {} }) => {
    const [deleting, toggleDeleting] = useState(false);
    const dispatch = useDispatch();

    const upgradePackages = useSelector(selectUpgradePackages);
    const commUpgradePackages = useSelector(selectCommUpgradePackages);

    const { components = {} } = useStateSelector("model.modelData") || {};

    const packageName = (!isCommunity) ? upgradePackages[toDelete]?.name : commUpgradePackages[toDelete]?.name;

    return (
        <Dialog open={!!toDelete}>
            <CloseDialog closeActions={() => toggleToDelete("")} />
            <div className={classes.dialog}>
                <h3>
                    Are you sure you want to delete{" "}
                    <strong>{packageName}</strong>?
                </h3>
                <div className={classes.footer}>
                    <Button type="hollow" onClick={() => toggleToDelete("")}>
                        Cancel
                    </Button>
                    <Button
                        onClick={async () => {
                            toggleDeleting(true);
                            if (isCommunity) {
                                // Remove this package's upgrades from the community's ecmInputMap (For running simulations)
                                Object.entries(commUpgradePackages[toDelete]?.upgrades || {})
                                    .forEach(async ([upgradeId, upgrade]) => {
                                        // TODO: Xaria Some upgrades missing subType?
                                        const upgradeSubType = upgrade.upgradeSubType ? upgrade.upgradeSubType : Object.keys(upgrade.label)[0];
                                        // console.log("Check if Necessary", upgrade.upgradeType, upgrade.upgradeSubType, Object.keys(upgrade.label)[0]);
                                        await dispatch(removeUpgradeFromCommunity(upgradeSubType, upgradeId));
                                });
                                // Delete package from the community's upgrades state + Delete capital cost (Populates upgrades table)
                                await dispatch(deleteCommUpgradePackage({ packageId: toDelete }));
                            }
                            else {
                                // Remove package reference from each selected component
                                Object.entries(upgradePackages[toDelete]?.upgrades || {}).forEach(([upgradeId, { selectedComponents }]) => {
                                    selectedComponents.map((path) => {
                                        // Search if component exists before removing its upgrade reference
                                        const componentData = resolveObj(path, components) || {};
                                        
                                        if (!isEmpty(componentData)) {
                                            const updatedPackages = Object.entries(componentData?.upgradePackages || {}).reduce((acc, [curKey, curVal]) => {
                                                if (curKey !== toDelete) {
                                                    return ({ ...acc, [curKey]: curVal });
                                                }
                                                return acc;
                                            }, {});
                            
                                            const componentModelPath = `model.modelData.components.${path}.upgradePackages`;
                                            modelChange(componentModelPath, updatedPackages);
                                        }
                                    });
                                });

                                // Delete package from model's upgrades state (Populates upgrades table)
                                await dispatch(deleteUpgradePackage({ packageId: toDelete }));
                            }
                            toggleToDelete("");
                            toggleDeleting(false);
                        }}
                        type="red"
                        disabled={deleting}
                    >
                        {deleting ? "Deleting..." : "Delete"}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default PackageDeleteDialog;
